import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5815f0fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner-padding"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "error-padding"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pvd3_spinner = _resolveComponent("pvd3-spinner")!
  const _component_ContentComponent = _resolveComponent("ContentComponent")!
  const _component_pvd3_alert = _resolveComponent("pvd3-alert")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.contentAvailable && !_ctx.contentError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_pvd3_spinner, {
            id: "content-spinner",
            "pvd-size": "large"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.contentAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ContentComponent)
        ]))
      : _createCommentVNode("", true),
    (_ctx.contentError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.contentError)
            ? (_openBlock(), _createBlock(_component_pvd3_alert, {
                key: 0,
                id: "content-error-id",
                "pvd-disable-a11y-attributes": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.clientConstants.CONTENT_UNAVAILABLE_ERROR), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}